export const ADD = 'entities/cause/ADD';
export const ADD_MULTIPLE = 'entities/cause/ADD_MULTIPLE';
export const UPDATE = 'entities/cause/UPDATE';
export const REMOVE = 'entities/cause/REMOVE';
